import Vue from 'vue'

import Router from 'vue-router'

import content from '@/layout/the-content'
import home from '@/pages/home'
import about from '@/pages/about'
import contacts from '@/pages/contacts'
import news from '@/pages/list/news'
import projects from '@/pages/list/projects'
import post from '@/pages/post'
import error from '@/pages/error'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: content,
      children: [
        {
          path: '/:lang?',
          name: 'home',
          component: home
        },
        {
          path: '/:lang/about',
          name: 'about',
          component: about
        },
        {
          path: '/:lang/contacts',
          name: 'contacts',
          component: contacts
        },
        {
          path: '/:lang/news',
          name: 'news',
          component: news
        },
        {
          path: '/:lang/news/:slug',
          name: 'story',
          component: post
        },
        {
          path: '/:lang/projects',
          name: 'projects',
          component: projects
        },
        {
          path: '/:lang/projects/:slug',
          name: 'project',
          component: post
        },
        {
          path: '/:lang/error',
          name: 'error',
          component: error
        },
        {
          path: '/:lang?/*',
          name: 'not-found',
          redirect: to => {
            if (to.params.lang && to.params.lang.match(/en|ru|ua/)) {
              return `/${to.params.lang}/error`
            }

            return '/en/error'
          }
        }
      ]
    }
  ],

  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.params.lang && !to.params.lang.match(/en|ru|ua/)) {
    next({
      path: '/en/error',
      query: {
        code: 404
        // errors: ['Invalid language']
      }
    })

    return
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js